export function selectedFilterLabels(config, values, offset = 0) {
  return compactFilterList(config.filter((item, index) => values[index + offset] && values[index + offset].value === true).map(item => item.label_name));
}
export function compactFilterList(values) {
  if (!values || !values.length) return 'Sin selección';
  return values.length > 4 ? values.slice(0, 3).join(' · ') + ' y ' + (values.length - 3) + ' más' : values.join(' · ');
}
export function filterDateRange(from, to) {
  const display = value => {
    if (!value || value === '01/01/1970') return '';
    if (value instanceof Date) return Number.isNaN(value.getTime()) ? '' : value.toLocaleDateString('es-ES');
    return String(value);
  };
  const start = display(from), end = display(to);
  if (!start && !end) return 'Cualquier fecha';
  return [start && 'Desde ' + start, end && 'hasta ' + end].filter(Boolean).join(' · ');
}
export function parseFilterDate(value) {
  if (!value || value === '01/01/1970') return '';
  const [day, month, year] = String(value).split('/').map(Number);
  if (!day || !month || !year) return '';
  const date = new Date(year, month - 1, day);
  return date.getDate() === day && date.getMonth() === month - 1 ? date : '';
}
